
<div class="d-flex wrapper">
    <div class="left">
        <app-sidebar ></app-sidebar>
    </div>
    <div class="right" #rightPanel>
        <app-header></app-header>
        <router-outlet></router-outlet>
        <app-footer></app-footer>
        
        <div class="mobile-header" *ngIf="isMobile">
            <div class="links">
              <a class="d-flex flex-column align-items-center" (click)="toggleSidebar()" translate>
                <svg-icon src="./assets/images/sidebar/menu-icon.svg" [svgStyle]="{ 'width.px': 24, 'height.px': 24 }"></svg-icon>menu
              </a>
              <a href="https://wsmcasino.com/" class="d-flex flex-column align-items-center" translate>
                <svg-icon src="./assets/images/sidebar/casino.svg" [svgStyle]="{ 'width.px': 24, 'height.px': 24 }"></svg-icon>casino
             </a>
             <a href="https://t.me/wsmcasinobot" class="d-flex flex-column align-items-center" translate>
               <svg-icon src="./assets/images/svg-icons/telegram-white.svg" [svgStyle]="{ 'width.px': 24, 'height.px': 24 }"></svg-icon> telegram
             </a>
              <a href="https://wsmcasino.com/sports" class="d-flex flex-column align-items-center" translate>
                <svg-icon src="./assets/images/sidebar/sport.svg" [svgStyle]="{ 'width.px': 24, 'height.px': 24 }"></svg-icon> sports
              </a>
              <a href="https://www.wsmcasino.com/en/promotions" class="d-flex flex-column align-items-center" translate>
                <svg-icon src="./assets/images/sidebar/promotions.svg" [svgStyle]="{ 'width.px': 24, 'height.px': 24 }"></svg-icon> promotions
              </a>
            </div>
          </div>
      </div>
    </div>
    


<!-- <div class="d-flex wrapper" [ngClass]="currentTab === 'pepe' ? 'active' : ''">
    <app-pepe-header></app-pepe-header>
    <router-outlet></router-outlet>
    <app-pepe-footer></app-pepe-footer>
</div> -->




